const STORAGE_KEY = "voz_simulador";

const clamp01 = (n) => {
    const v = Number(n);
    if (!Number.isFinite(v)) return 0;
    return Math.min(1, Math.max(0, v));
};

const formatBRL = (cents) => {
    const value = (Number(cents) || 0) / 100;
    return value.toLocaleString("pt-BR", {
        style: "currency",
        currency: "BRL",
    });
};

const formatPercentFromBP = (basisPoints) => {
    const value = (Number(basisPoints) || 0) / 100;
    return `${value.toLocaleString("pt-BR", {
        minimumFractionDigits: 0,
        maximumFractionDigits: 2,
    })}%`;
};

const setText = (root, selector, value) => {
    const el = root.querySelector(selector);
    if (el) el.textContent = value;
};

const setActiveMode = (root, mode) => {
    const buttons = root.querySelectorAll(".js-res-mode-btn");
    buttons.forEach((button) => {
        const isActive = button.dataset.mode === mode;
        button.classList.toggle("is-active", isActive);
        button.setAttribute("aria-pressed", isActive ? "true" : "false");
    });
};

export default function simuladorResultados() {
    const root = document.querySelector(".js-simulador-resultados");

    if (!root || root.dataset.init === "true") return;
    root.dataset.init = "true";

    let payload = null;

    try {
        const raw = sessionStorage.getItem(STORAGE_KEY);
        if (raw) payload = JSON.parse(raw);
    } catch (e) {}

    payload = payload && typeof payload === "object" ? payload : null;

    if (!payload) {
        const backUrl = root.getAttribute("data-back-url") || "/";
        window.location.href = backUrl;
        return;
    }

    const tipo = payload && payload.tipo ? String(payload.tipo) : "colegio";
    const meses = tipo === "faculdade" ? 6 : 12;

    const alunos =
        payload && Number.isFinite(Number(payload.alunos))
            ? Number(payload.alunos)
            : 0;

    const ticketCents =
        payload && Number.isFinite(Number(payload.ticket_cents))
            ? Number(payload.ticket_cents)
            : 0;

    const inadPeriodoBP =
        payload && Number.isFinite(Number(payload.inad_periodo_bp))
            ? Number(payload.inad_periodo_bp)
            : 0;

    const inadPosBP =
        payload && Number.isFinite(Number(payload.inad_pos_bp))
            ? Number(payload.inad_pos_bp)
            : 0;

    const receitaPrevistaCents = Math.max(
        0,
        Math.round(alunos * ticketCents * meses),
    );

    const taxaCustoAttr = root.getAttribute("data-taxa-custo") || "0.10";
    const taxaCusto = clamp01(
        Number(String(taxaCustoAttr).replace(",", ".")) || 0.1,
    );

    const prejuizoCustoCents = Math.round(receitaPrevistaCents * taxaCusto);
    const recebidaCustoCents = receitaPrevistaCents - prejuizoCustoCents;

    const scenarios = {
        periodo: {
            label: "Inadimplência acumulada",
            inadBP: inadPeriodoBP,
            vozRate: 0.05,
        },
        pos: {
            label: "Inadimplência pós-matrícula",
            inadBP: inadPosBP,
            vozRate: 0.01,
        },
    };

    let currentMode = "periodo";

    const render = () => {
        const scenario = scenarios[currentMode] || scenarios.periodo;
        const inadRate = clamp01(scenario.inadBP / 10000);

        const prejuizoPeriodoCents = Math.round(
            receitaPrevistaCents * inadRate,
        );
        const recebidaPeriodoCents =
            receitaPrevistaCents - prejuizoPeriodoCents;

        const prejuizoVozCents = Math.round(
            receitaPrevistaCents * scenario.vozRate,
        );
        const recebidaVozCents = receitaPrevistaCents - prejuizoVozCents;

        setActiveMode(root, currentMode);

        setText(root, ".js-res-mode-label", scenario.label);
        setText(root, ".js-res-mode-label-voz", scenario.label);

        setText(
            root,
            ".js-res-receita-prevista-p",
            formatBRL(receitaPrevistaCents),
        );
        setText(
            root,
            ".js-res-inad-periodo-p",
            formatPercentFromBP(scenario.inadBP),
        );
        setText(
            root,
            ".js-res-prejuizo-periodo-p",
            formatBRL(prejuizoPeriodoCents),
        );
        setText(
            root,
            ".js-res-recebida-periodo-p",
            formatBRL(recebidaPeriodoCents),
        );

        setText(
            root,
            ".js-res-receita-prevista-custo-p",
            formatBRL(receitaPrevistaCents),
        );
        setText(
            root,
            ".js-res-taxa-custo-p",
            `${(taxaCusto * 100).toLocaleString("pt-BR", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            })}%`,
        );
        setText(
            root,
            ".js-res-prejuizo-custo-p",
            formatBRL(prejuizoCustoCents),
        );
        setText(
            root,
            ".js-res-recebida-custo-p",
            formatBRL(recebidaCustoCents),
        );

        setText(
            root,
            ".js-res-receita-prevista-voz-p",
            formatBRL(receitaPrevistaCents),
        );
        setText(
            root,
            ".js-res-voz-rate-p",
            `${(scenario.vozRate * 100).toLocaleString("pt-BR", {
                minimumFractionDigits: 0,
                maximumFractionDigits: 2,
            })}%`,
        );
        setText(root, ".js-res-prejuizo-voz-p", formatBRL(prejuizoVozCents));
        setText(root, ".js-res-recebida-voz-p", formatBRL(recebidaVozCents));
    };

    root.addEventListener("click", (event) => {
        const button = event.target.closest(".js-res-mode-btn");
        if (!button) return;

        const nextMode = button.dataset.mode === "pos" ? "pos" : "periodo";
        if (nextMode === currentMode) return;

        currentMode = nextMode;
        render();
    });

    render();

    try {
        sessionStorage.removeItem(STORAGE_KEY);
    } catch (e) {}
}
